<template>
  <v-card>
    <v-container class="pb-0 pt-0">
      <v-card-title class="text-h5 mt-2 px-0">
        <v-row class="py-0">
          <v-col class="pt-1 pb-0">
            <v-card-actions class="px-0 py-0">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="closeDialog(false)"
                :icon="closeIcon"
                variant="text"
                id="v-btn-close-credenciales"
              >
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-4 pt-0">
            Gestión de Credenciales {{ isMobile ? "" : "-" }}
            {{ usuarioNombre }}
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="px-0">
        <v-card class="elevation-1 mb-3">
          <v-card-text class="py-0 my-0">
            <v-row>
              <v-col cols="12" class="mx-0 px-0">
                <v-data-table
                  :headers="headers"
                  :items="credencialesData"
                  item-value="id"
                  :loading="isLoading"
                  :hide-default-footer="credencialesData.length < 11"
                  :mobile="isMobile"
                  :hide-default-header="isMobile"
                  density="compact"
                  class="credentials-table"
                >
                  <template v-slot:[`item.actualizoCredenciales`]="{ item }">
                    <v-icon
                      small
                      :color="item.actualizoCredenciales ? 'green' : 'red'"
                    >
                      {{ item.actualizoCredenciales ? checkIcon : crossIcon }}
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <div class="text-center pa-4">
                      No hay registros de envío de credenciales
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Acciones de credenciales -->
        <!-- Layout para Desktop -->
        <v-row v-if="!isMobile">
          <v-col cols="12" class="d-flex justify-end pr-3">
            <v-btn
              color="primary"
              @click="openModalResendPassword"
              class="pr-7 mr-2"
              :disabled="isLoading"
              id="v-btn-reenviar-credenciales"
              v-if="permisosUsuarios.canReenviarContraseña"
            >
              <v-icon left>{{ resetPasswordIcon }}</v-icon>
              Reenviar contraseña
            </v-btn>
            <v-btn
              color="primary"
              @click="openModalRestorePassword"
              :disabled="isLoading"
              id="v-btn-restaurar-credenciales"
              v-if="permisosUsuarios.canRestorePassword"
            >
              <v-icon left>{{ restoreIcon }}</v-icon>
              Restaurar contraseña
            </v-btn>
          </v-col>
        </v-row>

        <!-- Layout para Mobile -->
        <template v-else>
          <!-- Botón Reenviar contraseña -->
          <v-row v-if="permisosUsuarios.canReenviarContraseña">
            <v-col cols="12" class="text-center py-2">
              <v-btn
                color="primary"
                @click="openModalResendPassword"
                :disabled="isLoading"
                id="v-btn-reenviar-credenciales-mobile"
                block
              >
                <v-icon left>{{ resetPasswordIcon }}</v-icon>
                Reenviar contraseña
              </v-btn>
            </v-col>
          </v-row>

          <!-- Botón Restaurar contraseña -->
          <v-row v-if="permisosUsuarios.canRestorePassword">
            <v-col cols="12" class="text-center py-2">
              <v-btn
                color="primary"
                @click="openModalRestorePassword"
                :disabled="isLoading"
                id="v-btn-restaurar-credenciales-mobile"
                block
              >
                <v-icon left>{{ restoreIcon }}</v-icon>
                Restaurar contraseña
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-container>

    <!-- Diálogos para acciones -->
    <v-dialog
      v-if="isOpenModalResendPassword && permisosUsuarios.canReenviarContraseña"
      v-model="isOpenModalResendPassword"
      :max-width="isMobile ? '95%' : '30%'"
      persistent
    >
      <ResendPassword :userId="userId" @closeDialog="closeResendDialog()" />
    </v-dialog>
    <v-dialog
      v-if="isOpenModalRestorePassword && permisosUsuarios.canRestorePassword"
      v-model="isOpenModalRestorePassword"
      :max-width="isMobile ? '95%' : '30%'"
      persistent
    >
      <RestorePassword :userId="userId" @closeDialog="closeRestoreDialog()" />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import enums from "@/utils/enums/index";
import RestorePassword from "@/components/shared/RestorePassword.vue";
import ResendPassword from "@/components/modules/usuarios/ResendPassword.vue";

export default {
  name: "GestionCredenciales",
  components: {
    RestorePassword,
    ResendPassword,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    usuarioNombre: {
      type: String,
      required: true,
      default: null,
    },
    usuarioCambioContraseñaLogin: {
      type: Boolean,
      required: false,
      default: false,
    },
    usuarioUltimoInicioSesion: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      credencialesData: [],
      isLoading: false,
      closeIcon: enums.icons.CLOSE_ICON,
      checkIcon: enums.icons.CHECK_ICON,
      crossIcon: enums.icons.CROSS_ICON,
      resetPasswordIcon: enums.icons.LOCK_RESET,
      restoreIcon: enums.icons.RESTORE_ICON,
      isOpenModalResendPassword: false,
      isOpenModalRestorePassword: false,
      headers: [
        {
          title: "Fecha envío",
          sortable: false,
          key: "fechaEnvioCredencial",
          width: "15%",
        },
        {
          title: "Credenciales actualizadas",
          sortable: false,
          key: "actualizoCredenciales",
          align: "center",
          width: "15%",
        },
        {
          title: "Datos de envío",
          sortable: false,
          key: "descripcionEnvioCredencial",
          width: "70%",
          align: "start",
        },
      ],
    };
  },
  created() {
    this.loadCredencialesData();
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
      permisos: "menu/permisos",
    }),
    permisosUsuarios() {
      let canRestorePassword = false;
      let canReenviarContraseña = false;

      if (this.permisos != null) {
        this.permisos.forEach((x) => {
          switch (x.permisoCodigo) {
            case enums.permises.RESTORE_PASSWORD.code:
              canRestorePassword = true;
              break;
            case enums.permises.REENVIAR_CONTRASEÑA.code:
              canReenviarContraseña = true;
              break;
            default:
              break;
          }
        });
      }
      return {
        canRestorePassword,
        canReenviarContraseña,
      };
    },
  },
  methods: {
    ...mapActions({
      getLogCredencialesByUserId: "user/getLogCredencialesByUserId",
    }),
    async loadCredencialesData() {
      this.isLoading = true;
      try {
        const response = await this.getLogCredencialesByUserId(this.userId);
        this.credencialesData = response;
      } catch (error) {
        console.error("Error al cargar datos de credenciales:", error);
        this.credencialesData = [];
      }
      this.isLoading = false;
    },
    openModalResendPassword() {
      this.isOpenModalResendPassword = true;
    },
    openModalRestorePassword() {
      this.isOpenModalRestorePassword = true;
    },
    closeResendDialog() {
      this.isOpenModalResendPassword = false;
      this.loadCredencialesData();
    },
    closeRestoreDialog() {
      this.isOpenModalRestorePassword = false;
      this.loadCredencialesData();
    },
    closeDialog(reload) {
      this.$emit("closeDialog", reload);
    },
  },
};
</script>

<style scoped></style>
